// reducers/authReducer.js
import { SET_ENGAGEMENT_TIME } from '../actions/authActions';


const initialState = {
  isAuthenticated: false,
  isLocalStorage: false,
  user: null,
  token: null,
  apiToken:null,
  engagementTime: 0,
  chatId: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_USER":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
      };
    case "LOGOUT_USER":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
      };
      case "SAVE_TOKEN":
        return {
          ...state,
          apiToken:  action.payload.apiToken,
        };
        case "MSAL_INSTANCE":
          return {
            ...state,
            isLocalStorage : true
          };
    case SET_ENGAGEMENT_TIME:
      console.log('Setting engagement time authreducer:', action.payload);
      return {
      ...state,
      engagementTime: action.payload.engagementTime,
      chatId: action.payload.chatId, // Update chatId in the state
    };

    default:
      return state;
  }
};

export default authReducer;
